module.exports = {
  siteName: 'Raid Gaming',
  baseUrl: '/',
  server: {
    host: process.env.VUE_APP_API_URL,
    port: process.env.VUE_APP_API_PORT,
    ssl: process.env.VUE_APP_API_SSL === 'true', // SSL/TLS?
  },
  authUri: process.env.VUE_APP_AUTH_URI,
};
